export default "__VITE_ASSET__DG$RNVEv__"